import Controlls from './component'

export default Controlls
